module.exports = {"510903001":"南津路街道","510903002":"凯旋路街道","510903004":"镇江寺街道","510903005":"育才路街道","510903006":"介福路街道","510903007":"嘉禾街道","510903008":"广德街道","510903009":"富源路街道","510903011":"灵泉街道","510903012":"慈音街道","510903013":"九莲街道","510903014":"南强街道","510903016":"西宁街道","510903017":"杨渡街道","510903100":"龙凤镇","510903101":"仁里镇","510903103":"永兴镇","510903104":"河沙镇","510903105":"新桥镇","510903106":"桂花镇","510903107":"老池镇","510903108":"保升镇","510903109":"北固镇","510903203":"唐家乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510903.json
// module id = 2447
// module chunks = 0